import { IOnInit } from "angular";
import { orderBy } from "lodash";
import { MachineGateway } from "../../../../models/machine";
import { MachinePartSummary } from "../../../../../shared/models/machineParts";
import { MachineConfiguration } from "../../../../../shared/models/machineConfiguration";
import { Machine } from "../../../../../shared/models/machine";

export class MachineDetailPartsComponentController implements IOnInit {
  static $inject = [];

  machine!: MachineGateway;
  machineParts!: MachinePartSummary<
    Machine<MachineConfiguration>,
    MachineConfiguration
  >;

  partGroups: any[] = [];
  transactionGroups: any[] = [];
  totalParts: number = 0;

  constructor() {}

  $onInit(): void {
    const transactionSorter = (transactionGroup: any) => transactionGroup.Time;
    const partSorter = (transaction: any) => transaction.Part.PartNumber;

    const transactions = orderBy(
      this.machineParts.Transactions,
      [transactionSorter, partSorter],
      ["desc", "asc"]
    );

    this.partGroups = this.getPartGroups(transactions);
    this.transactionGroups = this.getTransactionGroups(transactions);

    this.totalParts = this.transactionGroups.reduce(
      (totalParts, transactionGroup) => {
        const transactionCount: number = transactionGroup.transactions.reduce(
          (count: number, transaction: any) => {
            return count + transaction.QuantityChange;
          },
          0
        );
        return totalParts + transactionCount;
      },
      0
    );
  }

  private getTransactionGroups(transactions: any[]) {
    return transactions.reduce((result, next) => {
      let existingTransactionGroup = result.find(
        (r: any) => r.time.getTime() === next.Time.getTime()
      );
      if (existingTransactionGroup === undefined) {
        existingTransactionGroup = {
          time: next.Time,
          transactions: [],
          user: next.UserProfile,
          quantity: 0,
        };
        result.push(existingTransactionGroup);
      }

      existingTransactionGroup.transactions.push(next);
      existingTransactionGroup.quantity += next.QuantityChange;

      return result;
    }, []);
  }

  private getPartGroups(transactions: any[]) {
    return transactions.reduce((result, next) => {
      let partGroup = result.find((f: any) => f.part.Id === next.PartId);
      if (partGroup === undefined) {
        partGroup = {
          part: next.Part,
          transactions: [],
          quantity: 0,
          mostRecentTime: next.Time,
        };
        result.push(partGroup);
      }

      if (partGroup.mostRecentTime < next.Time) {
        partGroup.mostRecentTime = next.Time;
      }

      partGroup.transactions.push(next);
      partGroup.quantity += next.QuantityChange;
      return result;
    }, []);
  }
}
